import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogRef } from '@ddt-web/dialog';
import { DialogIcon } from '@ddt-web/domain';
import * as get from 'lodash/get';

@Component({
	templateUrl: './model-compare-dialog.component.html',
	styleUrls: ['./model-compare-dialog.component.scss']
})
export class ModelCompareDialogComponent implements OnInit {
	public readonly SELECTED_PORTFOLIO = 'SELECTED_PORTFOLIO';

	public dialogData: any;
	public imagePath: string;
	public selectedPortfolio: string;
	public isValidData: boolean;

	constructor(public dialogRef: DialogRef, private config: DialogConfig) {
		this.dialogData = config.data;
	}

	public ngOnInit(): void {
		this.isValidData = this.dialogData && get(this.dialogData, 'umaPortfolio[0]');
		if (this.isValidData) {
			this.imagePath = DialogIcon.EXCLAMATION_TRIANGLE;
			this.selectedPortfolio = get(this.dialogData, 'umaPortfolio[0]');
		}
	}

	public updateSelect(portfolio): void {
		this.selectedPortfolio = portfolio;
	}

	public onContinueClick(): void {
		this.dialogRef.close(this.SELECTED_PORTFOLIO);
	}

	public onCancelClick(): void {
		this.dialogRef.close();
	}
}
